<div class="avatar-container" [class]="size">
	<div class="user-avatar" [class.shadow]="shadow" [class]="bgDefault">
		<img [src]="avatar" [alt]="alt" onLoadImage [setOrientation]="true" [center]="center" [imgDefault]="userDefault" loading="lazy" />
	</div>
	<div class="avatar-flag" *ngIf="country">
		<img [src]="flag" width="19" height="14" [alt]="country" onLoadImage loading="lazy" />
	</div>
	<span *ngIf="notification" [class]="{ 'badge-md': size !== 'sm', 'badge-xs': size === 'sm' }" class="avatar-notification badge badge-danger rounded-circle">{{ size === "sm" ? "" : notification }}</span>
	<span *ngIf="checked" class="avatar-checked badge badge-md badge-outline-success rounded-circle"><i class="fas fa-check"></i></span>
</div>
